// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yJDC7O54GpznEVgRYlT2{position:relative}", "",{"version":3,"sources":["webpack://./src/course-handling/courses/overview/course-unit-participants/course-unit-participants.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA","sourcesContent":[".host {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"host": "yJDC7O54GpznEVgRYlT2"
};
export default ___CSS_LOADER_EXPORT___;
